import { defineComponent as _defineComponent } from 'vue'
import BaseDynamicTable, { dynamicTableProps } from 'ah-common-lib/src/common/components/listing/DynamicTable.vue';
import { TableFieldDefinition } from 'ah-common-lib/src/models';
import { ref, computed, useAttrs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'XHedgeDynamicTable',
  props: {
  ...dynamicTableProps,
  withRowSubView: {
    type: [Boolean, String, Function],
    default: false,
  },
  flush: {
    type: [Boolean, String],
    default: true,
  },
  /**
   * Breakpoint at which the table converts to a stacked view
   *
   * Also affects the application of the `table-stacked` class
   */
  breakpoint: {
    type: String,
    default: '900px',
  },
},
  setup(__props) {

const props = __props;

/**
 * Replaces DynamicTable from common-lib, including some default templates for sorting and toggling
 *
 * MUST be imported into Vue as "DynamicTable" to effectively replace the base implementation
 */



const expandedRows = ref<any[]>([]);

const tableFields = computed(() => {
  const fields: TableFieldDefinition[] = [...((useAttrs().fields as any) || [])];

  if (props.withRowDetails !== false || props.withRowSubView !== false) {
    fields.push({
      header: '',
      key: 'xHedgeSelectableToggle',
      class: 'toggle-col',
      sortable: false,
    });
  }

  return fields;
});

function xHedgeRowClass(item: any, type: any) {
  const classes = [];
  if (props.rowClass) {
    classes.push(typeof props.rowClass === 'function' ? props.rowClass(item, type) : props.rowClass);
  }

  if (props.selectedItems.includes(item[props.primaryKey])) {
    classes.push('selected-row');
  }

  if (hasDetailsOpen(item)) {
    classes.push('b-table-has-details');
  }

  if (hasRowDetails(item)) {
    classes.push('with-details');
  }

  if (hasRowSubView(item)) {
    classes.push('with-subview');
  }

  return classes.join(' ');
}

function hasDetailsOpen(item: any) {
  return item[props.primaryKey] && expandedRows.value.includes(item[props.primaryKey]);
}

function hasRowDetails(item: any) {
  return typeof props.withRowDetails === 'function' ? props.withRowDetails(item) : props.withRowDetails !== false;
}

function hasRowSubView(item: any) {
  return typeof props.withRowSubView === 'function' ? props.withRowSubView(item) : props.withRowSubView !== false;
}

return { __sfc: true,props, expandedRows, tableFields, xHedgeRowClass, hasDetailsOpen, hasRowDetails, hasRowSubView, BaseDynamicTable }
}

})